import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import DateOfBirth from 'features/application/screens/DateOfBirth/DateOfBirth';
import useCustomerApplicationOrigination from 'features/signup/hooks/useCustomerApplicationOrigination';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DateOfBirthWrapper = () => {
  const {
    application,
    fetching,
    error,
    reExecuteQuery,
    hasApplicationLoaded,
    isReapplication,
  } = useCustomerApplicationOrigination({
    sourceName: SourceName.PERSONAL_INFORMATION,
  });

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: application?.id,
    sourceName: SourceName.PERSONAL_INFORMATION,
  });

  const { t: translatedText } = useTranslation('signup', {
    keyPrefix: 'personalInfo',
  });

  return (
    <DateOfBirth
      prefilledDateOfBirth={application?.dateOfBirth as string}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      reExecuteQuery={reExecuteQuery}
      fetching={fetching}
      error={error as Error}
      isReapplication={isReapplication}
      hasApplicationLoaded={hasApplicationLoaded}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      buttonLabel={translatedText('buttons.next')}
      nextRoute="/signup/employment"
      backRoute="/signup/address-collection"
    />
  );
};

export default DateOfBirthWrapper;
